import { combineReducers } from 'redux'

import auth from './authReducer'
import documentos from './documentosReducer'
import signatario from './signatarioReducer'
import usuarios from './usersReducer'
import relatorio from './relatorioReducer'

export default combineReducers({
    auth,
    documentos,
    signatario,
    usuarios,
    relatorio
})